"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPlugins = exports.withDefaultOptions = exports.defaultOpts = exports.PLUGINS = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var CommonOutputTypes = _interopRequireWildcard(require("draft-content-plugins/lib/ContentOutputTypes"));

var _KnowledgeArticlesPlugin = _interopRequireDefault(require("draft-content-plugins/plugins/knowledgeArticles/KnowledgeArticlesPlugin"));

var _SnippetsPlugin = _interopRequireDefault(require("draft-content-plugins/plugins/snippets/SnippetsPlugin"));

var _createImageButton = _interopRequireDefault(require("draft-plugins/components/createImageButton"));

var _BackgroundColorPlugin = _interopRequireDefault(require("draft-plugins/plugins/BackgroundColorPlugin"));

var _BlockAlignment = _interopRequireDefault(require("draft-plugins/plugins/BlockAlignment"));

var _BlockStyles = _interopRequireDefault(require("draft-plugins/plugins/BlockStyles"));

var _ListStylesDropdown = _interopRequireDefault(require("draft-plugins/plugins/ListStylesDropdown"));

var _DocumentLinkPreviewPlugin = _interopRequireDefault(require("draft-plugins/plugins/DocumentLinkPreviewPlugin"));

var _FontStyles = _interopRequireDefault(require("draft-plugins/plugins/FontStyles"));

var _HighlightPlugin = _interopRequireDefault(require("draft-plugins/plugins/HighlightPlugin"));

var _BaseImagePlugin = _interopRequireDefault(require("draft-plugins/plugins/BaseImagePlugin"));

var _InlineStyleOverridePlugin = _interopRequireDefault(require("draft-plugins/plugins/InlineStyleOverridePlugin"));

var _InlineStyles = _interopRequireDefault(require("draft-plugins/plugins/InlineStyles"));

var _PluginGroup = _interopRequireDefault(require("draft-plugins/plugins/PluginGroup"));

var _Separator = _interopRequireDefault(require("draft-plugins/plugins/Separator"));

var _SizeStyles = _interopRequireDefault(require("draft-plugins/plugins/SizeStyles"));

var _TextColorPlugin = _interopRequireDefault(require("draft-plugins/plugins/TextColorPlugin"));

var _UnstyledAsDiv = _interopRequireDefault(require("draft-plugins/plugins/UnstyledAsDiv"));

var _AtMentionPlugin = _interopRequireDefault(require("draft-plugins/plugins/atmentions/AtMentionPlugin"));

var _link = _interopRequireDefault(require("draft-plugins/plugins/link"));

var _AdvancedColorPlugin = _interopRequireDefault(require("draft-plugins/plugins/AdvancedColorPlugin"));

var _createPluginButton = _interopRequireDefault(require("draft-plugins/utils/createPluginButton"));

var _createTextToolbarButton = _interopRequireDefault(require("draft-plugins/utils/createTextToolbarButton"));

var _VideoPlugin = _interopRequireDefault(require("draft-plugins/plugins/VideoPlugin"));

var _react = _interopRequireDefault(require("react"));

var _ColorPickerPopoverBody = _interopRequireDefault(require("react-colorpicker/popover/ColorPickerPopoverBody"));

var _RichTextEditorContent = require("./RichTextEditorContent");

var _SnippetsApi = _interopRequireDefault(require("./SnippetsApi"));

var PLUGINS = {
  advancedBackgroundColor: 'advancedBackgroundColor',
  advancedTextColor: 'advancedTextColor',
  atMention: 'atMention',
  backgroundColor: 'backgroundColor',
  blockAlignment: 'blockAlignment',
  blockStyles: 'blockStyles',
  fontStyles: 'fontStyles',
  hightlight: 'hightlight',
  image: 'image',
  inlineStyles: 'inlineStyles',
  inlineStylesOverride: 'inlineStylesOverride',
  link: 'link',
  listStyles: 'listStyles',
  separator: 'separator',
  sizeStyles: 'sizeStyles',
  textColor: 'textColor',
  unstyledAsDiv: 'unstyledAsDiv',
  knowledgeArticles: 'knowledgeArticles',
  snippets: 'snippets',
  documentLinkPreview: 'documentLinkPreview',
  video: 'video'
};
exports.PLUGINS = PLUGINS;

var formattingTooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
  message: "customerDataRte.plugins.tooltips.formatting"
});

var formattingPluginGroupOptions = {
  tooltip: formattingTooltip,
  tooltipPlacement: 'top right'
};
var defaultOpts = {
  atMentions: {
    dataProp: 'owners',
    tracker: function tracker() {},
    enabled: true
  },
  snippets: {
    tracker: function tracker() {},
    enabled: true
  },
  knowledgeArticles: {
    tracker: function tracker() {},
    enabled: false
  }
};
exports.defaultOpts = defaultOpts;

var withDefaultOptions = function withDefaultOptions(opts) {
  return Object.assign({}, defaultOpts, opts);
};

exports.withDefaultOptions = withDefaultOptions;

var createPlugins = function createPlugins(opts) {
  var hasToolbarBeta = opts.hasToolbarBeta,
      hasVideo = opts.hasVideo;
  var pluginConfig = {
    advancedBackgroundColor: {
      ColorPicker: _ColorPickerPopoverBody.default,
      cssProperty: 'backgroundColor',
      defaultColor: '#fff',
      iconName: 'highlight'
    },
    advancedTextColor: {
      ColorPicker: _ColorPickerPopoverBody.default
    },
    atMention: Object.assign({
      dataProp: null,
      useInviteZeroState: null,
      inviteZeroStateOpts: null,
      tokenToHTML: _RichTextEditorContent.atMentionTokenToHtml,
      htmlToToken: _RichTextEditorContent.atMentionHtmlToToken,
      tokenClassName: 'at-mention-token',
      tokenStyle: {}
    }, opts.atMentions),
    blockAlignment: {
      hasToolbarBeta: hasToolbarBeta,
      tagName: 'div',
      empty: '<br>'
    },
    blockStyles: {
      headerStyles: [],
      listStyles: ['ordered-list-item', 'unordered-list-item'],
      miscStyles: ['blockquote']
    },
    fontStyles: {
      hasToolbarBeta: hasToolbarBeta
    },
    image: {
      Button: (0, _createImageButton.default)((0, _extends2.default)({
        hasToolbarBeta: hasToolbarBeta,
        tooltipPlacement: 'top'
      }, opts.image))
    },
    link: Object.assign({
      hasToolbarBeta: hasToolbarBeta,
      showTarget: true,
      tooltipPlacement: 'top',
      popoverPlacement: 'top right'
    }, opts.link),
    inlineStyles: {
      hasToolbarBeta: hasToolbarBeta
    },
    sizeStyles: {
      hasToolbarBeta: hasToolbarBeta
    },
    snippets: Object.assign({
      outputType: CommonOutputTypes.RENDERED,
      button: hasToolbarBeta ? (0, _createTextToolbarButton.default)({
        icon: 'textSnippet',
        tooltip: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataRte.plugins.snippet"
        }),
        tooltipPlacement: 'top'
      }) : (0, _createPluginButton.default)({
        icon: 'textSnippet',
        toolTip: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataRte.plugins.tooltips.snippet"
        }),
        tooltipPlacement: 'top'
      }),
      apiWrapper: _SnippetsApi.default,
      popoverPlacement: 'top right'
    }, opts.snippets),
    knowledgeArticles: Object.assign({
      outputType: CommonOutputTypes.RENDERED,
      tracker: opts.knowledgeArticles.tracker,
      button: hasToolbarBeta ? (0, _createTextToolbarButton.default)({
        icon: 'cap',
        tooltip: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataRte.plugins.knowledgeArticle"
        }),
        tooltipPlacement: 'top'
      }) : (0, _createPluginButton.default)({
        icon: 'bulb',
        toolTip: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataRte.plugins.tooltips.knowledgeArticle"
        }),
        tooltipPlacement: 'top'
      }),
      popoverPlacement: 'top'
    }, opts.knowledgeArticles),
    video: {
      hasToolbarBeta: hasToolbarBeta,
      usePopover: opts.hasShepherdVideoUngated,
      handleVideoTracking: opts.handleVideoTracking
    }
  };
  var plugins = {
    advancedBackgroundColor: (0, _AdvancedColorPlugin.default)(pluginConfig.advancedBackgroundColor),
    advancedTextColor: (0, _AdvancedColorPlugin.default)(pluginConfig.advancedTextColor),
    atMention: (0, _AtMentionPlugin.default)(pluginConfig.atMention),
    backgroundColor: _BackgroundColorPlugin.default,
    blockAlignment: (0, _BlockAlignment.default)(pluginConfig.blockAlignment),
    blockStyles: (0, _BlockStyles.default)(pluginConfig.blockStyles),
    fontStyles: (0, _FontStyles.default)(pluginConfig.fontStyles),
    hightlight: _HighlightPlugin.default,
    image: (0, _BaseImagePlugin.default)(pluginConfig.image),
    inlineStyles: (0, _InlineStyles.default)(pluginConfig.inlineStyles),
    inlineStylesOverride: (0, _InlineStyleOverridePlugin.default)(),
    link: (0, _link.default)(pluginConfig.link),
    listStyles: (0, _ListStylesDropdown.default)(),
    separator: _Separator.default,
    sizeStyles: (0, _SizeStyles.default)(pluginConfig.sizeStyles),
    textColor: _TextColorPlugin.default,
    unstyledAsDiv: _UnstyledAsDiv.default,
    knowledgeArticles: (0, _KnowledgeArticlesPlugin.default)(pluginConfig.knowledgeArticles),
    snippets: (0, _SnippetsPlugin.default)(pluginConfig.snippets),
    documentLinkPreview: _DocumentLinkPreviewPlugin.default,
    video: (0, _VideoPlugin.default)(pluginConfig.video)
  };
  var externalInsertBeta = [plugins.snippets, plugins.knowledgeArticles];

  if (hasVideo) {
    externalInsertBeta.unshift(plugins.video);
  }

  var groups = {
    inline: {
      external: (0, _PluginGroup.default)((0, _extends2.default)({}, formattingPluginGroupOptions, opts.formattingPluginGroup), plugins.fontStyles, plugins.separator, plugins.sizeStyles, plugins.separator, plugins.inlineStyles, plugins.inlineStylesOverride, plugins.separator, plugins.textColor, plugins.backgroundColor, plugins.separator, plugins.blockStyles, plugins.blockAlignment, plugins.documentLinkPreview),
      externalBeta: (0, _PluginGroup.default)({
        useDropdown: true,
        dropdownText: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataRte.plugins.tooltips.more"
        }),
        dropdownButtonClassName: 'p-right-0'
      }, plugins.fontStyles, plugins.sizeStyles, plugins.advancedTextColor, plugins.advancedBackgroundColor, plugins.separator, plugins.blockAlignment, plugins.listStyles),
      externalInsertBeta: externalInsertBeta,
      internal: (0, _PluginGroup.default)((0, _extends2.default)({}, formattingPluginGroupOptions, opts.formattingPluginGroup), plugins.fontStyles, plugins.separator, plugins.sizeStyles, plugins.separator, plugins.inlineStyles, plugins.inlineStylesOverride, plugins.separator, plugins.blockStyles, plugins.blockAlignment, plugins.separator, plugins.hightlight)
    }
  };
  return {
    pluginConfig: pluginConfig,
    plugins: plugins,
    groups: groups
  };
};

exports.createPlugins = createPlugins;